export enum AppRouters {
    MAIN = 'main',
    CATALOG = 'catalog',
    PETS = 'pets',
};

export const getRouteMain = () => '/';
export const getRouteCatalog = () => '/catalog';
export const getRoutePets = () => '/pets';